import {
  gaqlenumCHAIN as CHAIN,
  gaqlenumARGRES as ARGRES,
  gaqlenumARGSIG as ARGSIG,
  gaqlenumQueryNameBRACKET as BRACKET,
  gaqlenumQueryNameRUN as RUN
} from './gaqlenum.js'

// q.do(q.args([q.expr(3), q.expr(4)]))
//  -> { 'gn:ARGRES': [ 3, 4] }
const gaqlchainArgResResolve = chainarg => chainarg[ARGRES]
const gaqlchainArgResIs = chainarg => (
  chainarg && typeof chainarg === 'object' && ARGRES in chainarg)

const gaqlchainIs = chain => (
  Array.isArray(chain) && chain[0] === CHAIN)

const gaqlchainIsShallow = chain => gaqlchainIs(chain) || (
  chain && typeof chain === 'object'
    && Object.values(chain).join().includes(CHAIN))

// TODO remove isArray check after query chains issues resolved
const gaqlchainIdGet = chain => Array.isArray(chain) && chain[1]
const gaqlchainRecsGet = chain => chain[2]

const gaqlchainIdCreate = (queryName, args, issub) => {
  const arity = queryName === RUN ? 0 : args.length
  const arg0 = args[0]

  if (issub)
    return `.${queryName}(${(
      arity === 1 ? arg0 : `(${args.join()})`)} => (…))`

  if (arg0 === ARGSIG)
    return args[3]

  const call = arity ? `(ay${arity})` : `()`

  if (queryName.endsWith('asfn'))
    return call

  return queryName === BRACKET
    ? 'q' + call
    : `.${queryName}${call}`
}

// creates chain from previous chain, incl nested row and sub query. ex,
//  * `map(hero => hero('name'))`
//  * `map(hero => ({ heroName: hero('name') }))`
const gaqlchainCreate = (chain, rec, id, recs = (chain[2] || [])) => ([
  CHAIN,
  id || ((gaqlchainIdGet(chain) || '')
    + (rec ? gaqlchainIdCreate(rec[0], rec[1] || []) : '')),
  rec ? ((recs = recs.slice()) && recs.push(rec) && recs) : recs
])

// ('.expr(user)') => true
// ('.expr(1)') => false
// ('.expr()') => false
const gaqlchainIsSub = chain =>
  gaqlchainIdGet(chain).indexOf('…') > -1

export {
  gaqlchainIs,
  gaqlchainIsSub,
  gaqlchainIsShallow,
  gaqlchainIdGet,
  gaqlchainIdCreate,
  gaqlchainRecsGet,
  gaqlchainCreate,
  gaqlchainArgResIs,
  gaqlchainArgResResolve,
  gaqlchainCreate as default
}
